// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".answered-by-box[data-v-5d9ea607]{z-index:2;position:relative}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
